import React from 'react';
import { useReservation } from "./ReservationContext";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { MenuCard } from './MenuCard';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './ColorTheme';
import { useMatomo } from '@datapunt/matomo-tracker-react'

const ReservationStep2 = () => {
  const { reservationState } = useReservation();
  const { slides } = reservationState;
  const { trackPageView } = useMatomo()

  // Track page view
  React.useEffect(() => {
    trackPageView({ documentTitle: 'Reservation Step 2' })
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} className={"padded"}>
          <Typography gutterBottom>
            Triff hier die Essenswahl für die ausgewählten Personen: Wir empfehlen Dir unser Menü für ein besonderes Geschmackserlebnis. Alternativ kannst du auch à la carte speisen.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }} >
          <Swiper
            speed={1000}
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView="auto"
            coverflowEffect={{
              rotate: 0,
              stretch: 80,
              depth: 200,
              modifier: 1,
              slideShadows: false,
            }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            modules={[Navigation, Autoplay, EffectCoverflow]}
            className="swiper-container"
          >
            {Object.entries(slides).map(([key, slide]) => (
              <SwiperSlide className="swiper-slide">
                <MenuCard slide={slide} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}

export default ReservationStep2;
